import { getToken } from './LocalStorageService';

// Force relative path to use Vercel proxy, or use env var if provided
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';
const PAGES_URL = `${API_BASE_URL}/pages`;

const getAuthHeaders = () => {
    const { access_token } = getToken();
    const headers = {
        'Content-Type': 'application/json'
    };
    if (access_token) {
        headers['Authorization'] = `Bearer ${access_token}`;
    }
    return headers;
};

const PageService = {
    async getPageBySlug(slug) {
        // Send token if available to bypass caching and allow viewing drafts for admins
        const headers = getAuthHeaders();

        // Add cache buster for admin requests to ensure fresh data
        const cacheBuster = `?_cb=${Date.now()}`;

        const response = await fetch(`${PAGES_URL}/${encodeURIComponent(slug)}${cacheBuster}`, {
            method: 'GET',
            headers: headers
        });

        if (!response.ok) {
            if (response.status === 404) {
                throw new Error('Page not found');
            }
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || errorData.message || 'Failed to fetch page data');
        }

        const resData = await response.json();
        return resData.data; // Assuming API returns { status: 'success', data: { ... } }
    },

    async createPage(pageData) {
        const response = await fetch(`${PAGES_URL}`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(pageData)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || errorData.message || `Failed to create page (${response.status} ${response.statusText})`);
        }

        const resData = await response.json();
        return resData.data;
    },

    async updatePage(slug, pageData) {
        console.log('[DEBUG] PageService: Updating page', slug, pageData);
        const response = await fetch(`${PAGES_URL}/${encodeURIComponent(slug)}`, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify(pageData)
        });

        console.log('[DEBUG] PageService: Response status', response.status);

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error('[DEBUG] PageService: Update failed', errorData);
            throw new Error(errorData.error || errorData.message || 'Failed to update page');
        }

        const resData = await response.json();
        console.log('[DEBUG] PageService: Update success', resData);
        return resData.data;
    },



    async deletePage(slug) {
        const response = await fetch(`${PAGES_URL}/${encodeURIComponent(slug)}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || errorData.message || 'Failed to delete page');
        }

        const resData = await response.json();
        return resData;
    },

    // For keeping compatibility if needed, though getPageBySlug is the main one used
    async getPage(slug) {
        return this.getPageBySlug(slug);
    },

    async getAllPages(params = {}) {
        const queryString = new URLSearchParams(params).toString();
        const response = await fetch(`${PAGES_URL}${queryString ? `?${queryString}` : ''}`, {
            method: 'GET',
            headers: getAuthHeaders()
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || errorData.message || 'Failed to fetch pages');
        }

        const resData = await response.json();
        return resData.data;
    }
};

export default PageService;
